import { Button, Surface } from "@heroui/react";
import { useNavigate } from "@tanstack/react-router";
import { ChevronRight, History, ShieldBan, ShieldCheck } from "lucide-react";
import StorageQuotaBar from "@repo/ui/pages/template_service/storage/StorageQuotaBar";
import { useStorageQuota } from "@repo/ui/pages/template_service/storage/useStorageQuota";
import PurchaseStorageModal from "./PurchaseStorageModal";

function MenuRow({
  label,
  onPress,
}: {
  label: string;
  onPress: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onPress}
      className="flex w-full items-center justify-between gap-2 p-4 text-left text-sm text-foreground hover:bg-default-50 rounded-lg transition-colors"
    >
      <span>{label}</span>
      <ChevronRight size={16} className="shrink-0 text-default-400" />
    </button>
  );
}

export default function MinePanel() {
  const navigate = useNavigate();
  const { data, isLoading, refetch } = useStorageQuota();

  return (
    <div className="flex w-full flex-col gap-4 px-4 pt-4 pb-8">
      <Surface variant="default" className="rounded-xl p-4 flex flex-col gap-6">
        <StorageQuotaBar
          size="lg"
          label="云空间用量"
          used={data?.used ?? 0}
          count={data?.count ?? 0}
          isPending={isLoading}
        />
        <div className="flex flex-row gap-2">
          <div className="w-full min-w-0">
            <PurchaseStorageModal
              onPaid={() => void refetch()}
              trigger={<Button className="w-full rounded-lg">购买扩容</Button>}
            />
          </div>
          <Button
            className="w-full rounded-lg"
            variant="tertiary"
            onPress={() => navigate({ to: "/template_protections/storage" })}
          >
            用量管理
          </Button>
        </div>
      </Surface>


      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <History size={14} />
          历史记录
        </h3>
        <Surface variant="default" className="rounded-xl">
          <MenuRow
            label="我的签收记录"
            onPress={() =>
              navigate({ to: "/template_protections/history/received" })
            }
          />
          <MenuRow
            label="我的发货记录"
            onPress={() => navigate({ to: "/template_protections/history/sent" })}
          />
        </Surface>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <ShieldBan size={14} />
          黑名单功能
        </h3>
        <Surface variant="default" className="rounded-xl">
          <MenuRow
            label="我拉黑的"
            onPress={() =>
              navigate({ to: "/template_protections/blacklist/self" })
            }
          />
          <MenuRow
            label="我订阅的"
            onPress={() =>
              navigate({ to: "/template_protections/blacklist/subscribed" })
            }
          />
          <MenuRow
            label="公共黑名单"
            onPress={() =>
              navigate({ to: "/template_protections/blacklist/public" })
            }
          />
        </Surface>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <ShieldCheck size={16} />
          更多功能
        </h3>
        <Surface variant="default" className="rounded-xl">
          <MenuRow
            label="标记提取"
            onPress={() => navigate({ to: "/template_trace" })}
          />
          <MenuRow
            label="可信查询"
            onPress={() =>
              navigate({ to: "/template_protections/trusted-query" })
            }
          />
        </Surface>
      </div>
    </div>
  );
}
